export default __webpack_public_path__ + "static/media/superbon-potato-crisps-vegshelf.fb4a0695.png";